import React from 'react';

function Resume() {
  const containerStyle = {
    padding: '2rem',
    maxWidth: '1200px',
    margin: '0 auto',
    background: '#1a1a1a',
    minHeight: '100vh',
    color: '#e0e0e0'
  };

  const contentStyle = {
    background: 'linear-gradient(135deg, rgba(30, 30, 46, 0.8), rgba(45, 45, 45, 0.8))',
    backdropFilter: 'blur(20px)',
    borderRadius: '16px',
    padding: '3rem',
    border: '1px solid rgba(0, 212, 255, 0.1)',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
    textAlign: 'center',
    position: 'relative',
    overflow: 'hidden'
  };

  const headingStyle = {
    color: '#ffffff',
    textShadow: '0 0 20px rgba(0, 212, 255, 0.3)',
    fontSize: '2.5rem',
    marginBottom: '2rem'
  };

  const previewContainerStyle = {
    margin: '2rem 0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '2rem'
  };

  const previewImageStyle = {
    maxWidth: '100%',
    height: 'auto',
    borderRadius: '8px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
    border: '2px solid rgba(0, 212, 255, 0.2)',
    cursor: 'pointer',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease'
  };

  const downloadButtonStyle = {
    padding: '1rem 2rem',
    fontSize: '1.1rem',
    fontWeight: '600',
    backgroundColor: '#00d4ff',
    color: '#1a1a1a',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    textDecoration: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.5rem',
    transition: 'all 0.3s ease',
    boxShadow: '0 4px 15px rgba(0, 212, 255, 0.3)'
  };

  const handleDownload = () => {
    // Use the actual PDF filename from the public folder
    const pdfUrl = '/Mikhail Ignatyev Resume.pdf';
    
    // Create a temporary link element
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = 'Mikhail_Ignatyev_Resume.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handlePreviewClick = () => {
    // Open the PDF in a new tab for full view
    window.open('/Mikhail Ignatyev Resume.pdf', '_blank');
  };

  return (
    <div style={containerStyle}>
      <div style={contentStyle}>
        <h1 style={headingStyle}>Resume</h1>
        
        {/* Download Button */}
        <button 
          style={downloadButtonStyle}
          onClick={handleDownload}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#00b8e6';
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 6px 20px rgba(0, 212, 255, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#00d4ff';
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 4px 15px rgba(0, 212, 255, 0.3)';
          }}
        >
          📄 DOWNLOAD RESUME PDF
        </button>
        
        <div style={previewContainerStyle}>
          {/* Resume Preview Image */}
          <img
            src="/resume.png"
            alt="Resume Preview"
            style={previewImageStyle}
            onClick={handlePreviewClick}
            onMouseEnter={(e) => {
              e.target.style.transform = 'scale(1.02)';
              e.target.style.boxShadow = '0 6px 25px rgba(0, 212, 255, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'scale(1)';
              e.target.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.3)';
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default Resume; 